import React from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import type { StackScreenProps } from "@react-navigation/stack";
import { AllergiesProvider } from "./AllergiesContext";
import { AllergiesIntroScreen } from "./AllergiesIntroScreen/AllergiesIntroScreen";
import { AllergiesDetailsScreen } from "./AllergiesDetailsScreen/AllergiesDetailsScreen";
import { AllergiesCompleteScreen } from "./AllergiesCompleteScreen/AllergiesCompleteScreen";
import { MedicalHistoryQuestionProvider } from "@src/packages/medical-history/components";

export type AllergiesStackParamList = {
  AllergiesIntro: undefined;
  AllergiesDetails: undefined;
  AllergiesComplete: undefined;
};

export type AllergiesStackScreenProps<T extends keyof AllergiesStackParamList> =
  StackScreenProps<AllergiesStackParamList, T>;

const Stack = createNativeStackNavigator<AllergiesStackParamList>();

export function AllergiesNavigator() {
  return (
    <AllergiesProvider>
      <MedicalHistoryQuestionProvider
        section="allergies"
        sectionLabelKey="med_history.review.section_title.allergies"
        helpTextKey="med_history.question_screen.flow_help.allergies"
      >
        <Stack.Navigator
          initialRouteName="AllergiesIntro"
          screenOptions={{
            headerShown: false,
            contentStyle: { backgroundColor: "transparent" },
          }}
        >
          <Stack.Screen
            name="AllergiesIntro"
            component={AllergiesIntroScreen}
          />
          <Stack.Screen
            name="AllergiesDetails"
            component={AllergiesDetailsScreen}
          />
          <Stack.Screen
            name="AllergiesComplete"
            component={AllergiesCompleteScreen}
          />
        </Stack.Navigator>
      </MedicalHistoryQuestionProvider>
    </AllergiesProvider>
  );
}
